"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyListItemDto = instanceOfPropertyListItemDto;
exports.PropertyListItemDtoFromJSON = PropertyListItemDtoFromJSON;
exports.PropertyListItemDtoFromJSONTyped = PropertyListItemDtoFromJSONTyped;
exports.PropertyListItemDtoToJSON = PropertyListItemDtoToJSON;
exports.PropertyListItemDtoToJSONTyped = PropertyListItemDtoToJSONTyped;
var InspectionSlotDto_1 = require("./InspectionSlotDto");
var PropertyDocumentEnquiryDto_1 = require("./PropertyDocumentEnquiryDto");
/**
 * Check if a given object implements the PropertyListItemDto interface.
 */
function instanceOfPropertyListItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('slug' in value) || value['slug'] === undefined)
        return false;
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('allowPrivateInspection' in value) || value['allowPrivateInspection'] === undefined)
        return false;
    if (!('openInspections' in value) || value['openInspections'] === undefined)
        return false;
    if (!('documents' in value) || value['documents'] === undefined)
        return false;
    return true;
}
function PropertyListItemDtoFromJSON(json) {
    return PropertyListItemDtoFromJSONTyped(json, false);
}
function PropertyListItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'],
        'slug': json['slug'],
        'listingId': json['listingId'],
        'allowPrivateInspection': json['allowPrivateInspection'],
        'openInspections': (json['openInspections'].map(InspectionSlotDto_1.InspectionSlotDtoFromJSON)),
        'documents': (json['documents'].map(PropertyDocumentEnquiryDto_1.PropertyDocumentEnquiryDtoFromJSON)),
        'state': json['state'] == null ? undefined : json['state'],
    };
}
function PropertyListItemDtoToJSON(json) {
    return PropertyListItemDtoToJSONTyped(json, false);
}
function PropertyListItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'slug': value['slug'],
        'listingId': value['listingId'],
        'allowPrivateInspection': value['allowPrivateInspection'],
        'openInspections': (value['openInspections'].map(InspectionSlotDto_1.InspectionSlotDtoToJSON)),
        'documents': (value['documents'].map(PropertyDocumentEnquiryDto_1.PropertyDocumentEnquiryDtoToJSON)),
        'state': value['state'],
    };
}
